import { defineAsyncComponent } from "vue";

export default Object.assign(
  {},
  defineAsyncComponent(() => import("./column-input.vue")),
  { Filter: defineAsyncComponent(() => import("./filter.vue")) },
);
